/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon16Solid = forwardRef('ArrowDCornerUpRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.634 1.616a1.25 1.25 0 0 0-1.768 1.768l2.366 2.366H4A3.25 3.25 0 0 0 .75 9v5.75a1.25 1.25 0 1 0 2.5 0V9A.75.75 0 0 1 4 8.25h7.232l-2.366 2.366a1.25 1.25 0 0 0 1.768 1.768l3.651-3.652a2.45 2.45 0 0 0 0-3.464l-3.651-3.652Z" })));
});
